import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppFacade } from '@app/app.facade';
import { SearchProperties } from '@avo/interface/trigger-props';
import { mapSearchProperties } from '@app/modules/core/mappers/amplitude-mappers';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';
import { BaseSearchBarFacade } from '@shared/base-search-bar/base-search-bar-facade';

@Injectable()
export class PropertiesAmplitudeService {

  constructor(
    private readonly route: ActivatedRoute,
    private readonly appFacade: AppFacade,
    private readonly baseSearchBarFacade: BaseSearchBarFacade,
  ) { }

  public searchProperties$(searchBy: SearchBy, searchId?: string): Observable<SearchProperties> {
    return combineLatest([
      this.route.paramMap,
      this.baseSearchBarFacade.searchData$,
      this.getSearchId$(searchBy),
    ]).pipe(
      map(([param, data, _searchId]) => {
        const paramSearchId = searchId || param.get('searchId') || _searchId;
        return mapSearchProperties(data, searchBy, paramSearchId);
      })
    );
  }

  private getSearchId$(searchBy: SearchBy): Observable<string> {
    switch (searchBy) {
      case SearchBy.HOTELS:
      case SearchBy.BYHOURS:
        return this.hotelSearchId$;
      case SearchBy.BUSES:
        return this.busSearchId$;
      case SearchBy.AUTOS:
        return this.autosSearchId$;
      case SearchBy.PACKAGES:
        return this.packageSearchId$;
      case SearchBy.ACTIVITIES:
        return this.activitiesSearchId$;
      default:
        return this.flightSearchId$;
    }
  }

  private get flightSearchId$(): Observable<string> {
    return this.appFacade.flightSearchId$;
  }

  private get busSearchId$(): Observable<string> {
    return this.appFacade.busSearchId$;
  }

  private get hotelSearchId$(): Observable<string> {
    return this.appFacade.hotelSearchId$;
  }

  private get autosSearchId$(): Observable<string> {
    return this.appFacade.autosSearchId$;
  }

  private get packageSearchId$(): Observable<string> {
    return this.appFacade.packageSearchId$;
  }

  private get activitiesSearchId$(): Observable<string> {
    return this.appFacade.activitiesSearchId$;
  }

}
